import { render } from "./PuxGet.pug?vue&type=template&id=172faa85&lang=pug"
import script from "./PuxGet.js?vue&type=script&lang=js"
export * from "./PuxGet.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__